import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/game/bg.png'
import closeBtn from '../assets/images/game/close.png';

import engineBtn from '../assets/images/game/btn-engine.png';
import fuelBtn from '../assets/images/game/btn-fuel.png';
import oilBtn from '../assets/images/game/btn-oil.png';
import rivetBtn from '../assets/images/game/btn-rivet.png';
import tireBtn from '../assets/images/game/btn-tire.png';
import engineBtnSelected from '../assets/images/game/btn-engine-selected.png';
import fuelBtnSelected from '../assets/images/game/btn-fuel-selected.png';
import oilBtnSelected from '../assets/images/game/btn-oil-selected.png';
import rivetBtnSelected from '../assets/images/game/btn-rivet-selected.png';
import tireBtnSelected from '../assets/images/game/btn-tire-selected.png';

import add10 from '../assets/images/game/add-10.png';
import check from '../assets/images/game/check.png';
import fixPart from '../assets/images/game/fix-part.png';
import blueAircraft from '../assets/images/game/blue-aircraft.png';
import greenAircraft from '../assets/images/game/green-aircraft.png';
import redAircraft from '../assets/images/game/red-aircraft.png';
import yellowAircraft from '../assets/images/game/yellow-aircraft.png';
import gameTimeoutImage from '../assets/images/game/game-timeout.png';
import wrongAnswer from '../assets/images/game/wrong.png';

import manualBackground from '../assets/images/game/manual-bg.png';
import manualBtn from '../assets/images/game/manual-btn.png';

class Game extends Component {

    countdownInterval = null;
    btnSound = './sounds/btn1.mp3';
    wrongSound = './sounds/wrong_sound.mp3';
    correctSound = './sounds/correct.mp3';
    checkSound = './sounds/check.mp3';
    repairSound = './sounds/repair.mp3';
    gameAnswer = [ 
        [ 
            { 
                btn: 4,
                check: 0
            } 
        ], 
        [ 
            { 
                btn: 1,
                check: 0
            }, 
            {
                btn: 0,
                check: 1
            } 
        ],
        [
            {
                btn: 1,
                check: 0
            },
            {
                btn: 4,
                check: 1
            },
            {
                btn: 3,
                check: 2
            }
        ],[
            {
                btn: 0,
                check: 0
            },
            {
                btn: 2,
                check: 3
            },
            {
                btn: 3,
                check: 2
            },
            {
                btn: 4,
                check: 1
            }
        ]
    ]
    currentAnswer = []
    add10AnimateInterval = 150;
    add10Animate1 = null;
    add10Animate2 = null;
    add10Animate3 = null;
    add10Animate4 = null;
    add10Animate5 = null;
    wrongAnswerAnimateTime = 150;
    wrongAnserInterval = null;

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            countdown: 60,
            score: 0,
            currentStage: 0,
            playing: false,
            gameOverTimeout: false,
            gameCompleted: false,
            check1Opacity: 0,
            check2Opacity: 0,
            check3Opacity: 0,
            check4Opacity: 0,
            add10Opacity1: 0,
            add10Opacity2: 0,
            add10Opacity3: 0,
            add10Opacity4: 0,
            add10Opacity5: 0,
            currentSelectedBtnIndex: -1,
            wrongAnswerOpacity: 0
        };
    }

    componentDidMount() {
        this.setState({
            playing: true
        });
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                this.setState({
                    gameOverTimeout: true,
                    playing: false
                });
                setTimeout(() => {
                    this.goToResultPage();
                }, 1000);
            } else {
                this.setState({
                    countdown: this.state.countdown - 1
                });
            }
        }, 1 * 1000);
    }

    componentWillUnmount() {
        this.setState({ playing : false });
        clearInterval(this.countdownInterval);
        if (this.add10Animate1 !== null) {
            clearInterval(this.add10Animate1);
        }
        if (this.add10Animate2 !== null) {
            clearInterval(this.add10Animate2);
        }
        if (this.add10Animate3 !== null) {
            clearInterval(this.add10Animate3);
        }
        if (this.add10Animate4 !== null) {
            clearInterval(this.add10Animate4);
        }
        if (this.add10Animate5 !== null) {
            clearInterval(this.add10Animate5);
        }
    }

    wrongAnswerAnimate() {
        this.playWrongSound();
        if (this.wrongAnserInterval !== null) {
            clearInterval(this.wrongAnserInterval);
            this.wrongAnserInterval = null;
        }
        this.setState({
            wrongAnswerOpacity: 1
        });
        this.wrongAnserInterval = setInterval(() => {
            if (this.state.wrongAnswerOpacity === 0.0) {
                clearInterval(this.wrongAnserInterval);
                this.wrongAnserInterval = null;
            } else {
                this.setState({
                    wrongAnswerOpacity: this.state.wrongAnswerOpacity - 0.2
                });
            }
        }, this.wrongAnswerAnimateTime);
    }

    add10AtIndex(btnIndex) {
        if (!this.state.playing) return;
        if (btnIndex === 0) {
            this.setState({
                add10Opacity1: 1
            });
            if (this.add10Animate1 != null) {
                clearInterval(this.add10Animate1);
                this.add10Animate1 = null;
            }
            this.add10Animate1 = setInterval(() => {
                if (this.state.add10Opacity1 === 0.0) {
                    clearInterval(this.add10Animate1);
                    this.add10Animate1 = null;
                } else {
                    this.setState({
                        add10Opacity1: this.state.add10Opacity1 - 0.2
                    });
                }
            }, this.add10AnimateInterval);
        } else if (btnIndex === 1) {
            this.setState({
                add10Opacity2: 1
            });
            if (this.add10Animate2 != null) {
                clearInterval(this.add10Animate2);
                this.add10Animate2 = null;
            }
            this.add10Animate2 = setInterval(() => {
                if (this.state.add10Opacity2 === 0.0) {
                    clearInterval(this.add10Animate2);
                    this.add10Animate2 = null;
                } else {
                    this.setState({
                        add10Opacity2: this.state.add10Opacity2 - 0.2
                    });
                }
            }, this.add10AnimateInterval);
        } else if (btnIndex === 2) {
            this.setState({
                add10Opacity3: 1
            });
            if (this.add10Animate3 != null) {
                clearInterval(this.add10Animate3);
                this.add10Animate3 = null;
            }
            this.add10Animate3 = setInterval(() => {
                if (this.state.add10Opacity3 === 0.0) {
                    clearInterval(this.add10Animate3);
                    this.add10Animate3 = null;
                } else {
                    this.setState({
                        add10Opacity3: this.state.add10Opacity3 - 0.2
                    });
                }
            }, this.add10AnimateInterval);
        } else if (btnIndex === 3) {
            this.setState({
                add10Opacity4: 1
            });
            if (this.add10Animate4 != null) {
                clearInterval(this.add10Animate4);
                this.add10Animate4 = null;
            }
            this.add10Animate4 = setInterval(() => {
                if (this.state.add10Opacity4 === 0.0) {
                    clearInterval(this.add10Animate4);
                } else {
                    this.setState({
                        add10Opacity4: this.state.add10Opacity4 - 0.2
                    });
                }
            }, this.add10AnimateInterval);
        } else if (btnIndex === 4) {
            this.setState({
                add10Opacity5: 1
            });
            if (this.add10Animate5 != null) {
                clearInterval(this.add10Animate5);
                this.add10Animate5 = null;
            }
            this.add10Animate5 = setInterval(() => {
                if (this.state.add10Opacity5 === 0.0) {
                    clearInterval(this.add10Animate5);
                    this.add10Animate5 = null;
                } else {
                    this.setState({
                        add10Opacity5: this.state.add10Opacity5 - 0.2
                    });
                }
            }, this.add10AnimateInterval);
        }
    }

    btnClick(btnIndex) {
        if (!this.state.playing) return;
        this.playBtnSound();
        this.setState({
            currentSelectedBtnIndex: btnIndex
        });
    }

    markerClick(checkIndex) {
        if (!this.state.playing) return;
        this.playBtnSound();
        let btnIndex = this.state.currentSelectedBtnIndex;
        let stageIndex = this.state.currentStage;
        let answer = this.gameAnswer[stageIndex];
        let correct = false;
        for (let i = 0; i < answer.length; i++) {
            if (answer[i].btn === btnIndex && answer[i].check === checkIndex) {
                correct = true;
            }
        }
        if (correct) {
            if (!this.currentAnswer.includes(btnIndex)) {
                this.playCorrectSound();
                setTimeout(() => {
                    this.playCheckSound();
                }, 1000);
                this.currentAnswer.push(btnIndex);
                if (checkIndex === 0) {
                    this.setState({
                        check1Opacity: 1.0,
                        score: this.state.score + 10
                    });
                } else if (checkIndex === 1) {
                    this.setState({
                        check2Opacity: 1.0,
                        score: this.state.score + 10
                    });
                } else if (checkIndex === 2) {
                    this.setState({
                        check3Opacity: 1.0,
                        score: this.state.score + 10
                    });
                } else if (checkIndex === 3) {
                    this.setState({
                        check4Opacity: 1.0,
                        score: this.state.score + 10
                    });
                }
                if (answer.length === this.currentAnswer.length) {
                    setTimeout(() => {
                        this.goToNextStage();
                    }, 1000);
                }
                this.add10AtIndex(btnIndex);
            }
        } else {
            this.playWrongSound();
            this.wrongAnswerAnimate();
        }
        this.setState({
            currentSelectedBtnIndex: -1
        });
    }

    // btnClick(btnIndex) {
    //     if (!this.state.playing) return;
    //     let stageIndex = this.state.currentStage;
    //     let answer = this.gameAnswer[stageIndex];
    //     if (!this.currentAnswer.includes(btnIndex)) {
    //         let checkIndex = -1;
    //         for (let i = 0; i < answer.length; i++) {
    //             if (answer[i].btn === btnIndex) {
    //                 checkIndex = answer[i].check;
    //             }
    //         }
    //         if (checkIndex !== -1) {
    //             this.currentAnswer.push(btnIndex);
    //             if (checkIndex === 0) {
    //                 this.setState({
    //                     check1Opacity: 1.0,
    //                     score: this.state.score + 10
    //                 });
    //             } else if (checkIndex === 1) {
    //                 this.setState({
    //                     check2Opacity: 1.0,
    //                     score: this.state.score + 10
    //                 });
    //             } else if (checkIndex === 2) {
    //                 this.setState({
    //                     check3Opacity: 1.0,
    //                     score: this.state.score + 10
    //                 });
    //             } else if (checkIndex === 3) {
    //                 this.setState({
    //                     check4Opacity: 1.0,
    //                     score: this.state.score + 10
    //                 });
    //             }
    //             if (answer.length === this.currentAnswer.length) {
    //                 setTimeout(() => {
    //                     this.goToNextStage();
    //                 }, 1000);
    //             }
    //             this.add10AtIndex(btnIndex);
    //         }
    //     }
    // }
    
    goToNextStage() {
        this.currentAnswer = []
        if (this.state.currentStage === 3) {
            this.setState({
                gameCompleted: true
            });
            setTimeout(() => {
                this.goToResultPage();
            }, 1 * 1000);
        } else {
            this.setState({
                check1Opacity: 0,
                check2Opacity: 0,
                check3Opacity: 0,
                check4Opacity: 0,
                currentStage: this.state.currentStage + 1,
                currentSelectedBtnIndex: -1
            });
        }
    }

    goToResultPage() {
        this.props.history.push({
            pathname: './result',
            state: {
                score: this.state.score
            }
        });
    };

    showDialog() {
        this.playRepairSound();
        this.setState({
            showDialog: true
        });
    }

    closeDialog() {
        this.playBtnSound();
        this.setState({
            showDialog: false
        });
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    playWrongSound() {
        let btnAudio = new Audio(this.wrongSound);
        btnAudio.play();
    }

    playCorrectSound() {
        let btnAudio = new Audio(this.correctSound);
        btnAudio.play();
    }

    playRepairSound() {
        let btnAudio = new Audio(this.repairSound);
        btnAudio.play();
    }

    playCheckSound() {
        let btnAudio = new Audio(this.checkSound);
        btnAudio.play();
    }

    getStageAircraft() {
        let stageIndex = this.state.currentStage;
        if (stageIndex === 0) {
            return redAircraft;
        } else if (stageIndex === 1) {
            return yellowAircraft;
        } else if (stageIndex === 2) {
            return greenAircraft;
        } else if (stageIndex === 3) {
            return blueAircraft;
        }
        return null;
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={this.getStageAircraft()} style={{ position: 'absolute', width: '100%', left: '0%', top: '0%' }}></img> 
                <img alt='' className='press-btn' src={this.state.currentSelectedBtnIndex === 0 ? tireBtnSelected : tireBtn} style={{ width: '10.05%', left: '11.2%', bottom: '4%', position: 'absolute' }} onClick={() => this.btnClick(0)}/>
                <img alt='' className='press-btn' src={this.state.currentSelectedBtnIndex === 1 ? engineBtnSelected : engineBtn} style={{ width: '10.05%', left: '22.2%', bottom: '4%', position: 'absolute' }} onClick={() => this.btnClick(1)}/>
                <img alt='' className='press-btn' src={this.state.currentSelectedBtnIndex === 2 ? oilBtnSelected : oilBtn} style={{ width: '10.05%', left: '33.3%', bottom: '4%', position: 'absolute' }} onClick={() => this.btnClick(2)}/>
                <img alt='' className='press-btn' src={this.state.currentSelectedBtnIndex === 3 ? rivetBtnSelected : rivetBtn} style={{ width: '10.05%', left: '44.13%', bottom: '4%', position: 'absolute' }} onClick={() => this.btnClick(3)}/>
                <img alt='' className='press-btn' src={this.state.currentSelectedBtnIndex === 4 ? fuelBtnSelected : fuelBtn} style={{ width: '10.05%', left: '55.15%', bottom: '4%', position: 'absolute' }} onClick={() => this.btnClick(4)}/>

                <div style={{ position: 'absolute', right: '42.2%', top: '14.7%', width: '5.3%', height: '7%', color: '#086940' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="180" fill="#086940" >{this.state.currentStage}</text>
                    </svg>
                </div>

                <div style={{ position: 'absolute', right: '4.5%', top: '8.5%', width: '6%', height: '8%', color: '#086940' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#086940" >{this.state.countdown}</text>
                    </svg>
                </div>
                <div style={{ position: 'absolute', left: '50.5%', top: '3.8%', width: '6%', height: '10%', color: 'white' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="250" fill="white" >{this.state.score}</text>
                    </svg>
                </div>

                <div style={{ position: 'absolute', width: '6%', height: '32%', left: '4%', top: '37%' }}>
                    <img alt='' src={check} style={{ width: '38%', position: 'absolute', left: '30%', top: '10%', opacity: `${ this.state.check1Opacity }` }}></img>
                    <img alt='' src={check} style={{ width: '38%', position: 'absolute', left: '30%', top: '33.5%', opacity: `${ this.state.check2Opacity }` }}></img>
                    <img alt='' src={check} style={{ width: '38%', position: 'absolute', left: '30%', top: '57%', opacity: `${ this.state.check3Opacity }` }}></img>
                    <img alt='' src={check} style={{ width: '38%', position: 'absolute', left: '30%', top: '80%', opacity: `${ this.state.check4Opacity }` }}></img>
                </div>
                {
                    this.state.currentStage === 0 && <>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '62.5%', top: '42%', opacity: this.state.check1Opacity === 1 ? 0 : 1 }} onClick={() => this.markerClick(0)}></img>
                    </>
                }
                {
                    this.state.currentStage === 1 && <>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '33%', top: '50%', opacity: this.state.check2Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(1)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '50%', top: '45%', opacity: this.state.check1Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(0)}></img>    
                    </>
                }
                {
                    this.state.currentStage === 2 && <>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '62.5%', top: '42%', opacity: this.state.check2Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(1)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '50%', top: '45%', opacity: this.state.check1Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(0)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '81.5%', top: '25%', opacity: this.state.check3Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(2)}></img>
                    </>
                }
                {
                    this.state.currentStage === 3 && <>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '62.5%', top: '42%', opacity: this.state.check2Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(1)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '33%', top: '50%', opacity: this.state.check1Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(0)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '81.5%', top: '25%', opacity: this.state.check3Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(2)}></img>
                        <img alt='' className='press-btn' src={fixPart} style={{ position: 'absolute', width: '6.2%', left: '58.7%', top: '51%', opacity: this.state.check4Opacity === 1 ? 0 : 1  }} onClick={() => this.markerClick(3)}></img>
                    </>
                }
                
                <img alt='' className='press-btn' src={manualBtn} style={{ width: '11.6%', right: '2%', bottom: '3.2%', position: 'absolute' }} onClick={ this.showDialog.bind(this) }/>
                {
                    this.state.showDialog && (<div>
                        <img alt='' src={manualBackground} style={{ position: 'absolute', width: '100%', left: '0%', top: '0%' }}></img>
                        <img alt='' className='press-btn' src={closeBtn} style={{ position: 'absolute', width: '14.47%', right: '6%', bottom: '9%' }} onClick={this.closeDialog.bind(this)}></img>
                    </div>)
                }
                <img alt='' src={add10} style={{ position: 'absolute', width: '11.97%', left: '30%', top: '37%', opacity: `${ this.state.add10Opacity1 }` }}></img>
                <img alt='' src={add10} style={{ position: 'absolute', width: '11.97%', left: '47%', top: '34%', opacity: `${ this.state.add10Opacity2 }` }}></img>
                <img alt='' src={add10} style={{ position: 'absolute', width: '11.97%', left: '55.7%', top: '66%', opacity: `${ this.state.add10Opacity3 }` }}></img>
                <img alt='' src={add10} style={{ position: 'absolute', width: '11.97%', left: '78.5%', top: '14%', opacity: `${ this.state.add10Opacity4 }` }}></img>
                <img alt='' src={add10} style={{ position: 'absolute', width: '11.97%', left: '59.5%', top: '30%', opacity: `${ this.state.add10Opacity5 }` }}></img>
                <img alt='' src={wrongAnswer} style={{ position: 'absolute', width: '10.9%', left: '48.5%', top: '28%', opacity: `${ this.state.wrongAnswerOpacity }` }}></img>
                {
                    this.state.gameOverTimeout && <img alt='' src={gameTimeoutImage} style={{ position: 'absolute', width: '31.87%', left: '35%', top: '36%' }}></img>
                }
            </div>
        )
    }
}

export default withRouter(Game);
